<template>
  <div class="settings">
    <h1>
      Inställningar
    </h1>

    <ul>
      <li class="setting" v-for="[key, setting] of Object.entries(clonedSettings).filter(([k, s]) => !s.custom)" :key="key">
        <h2>{{ copy[key] }}</h2>

        <div class="time-container" v-if="setting.type === 'JSON'">
          <div class="json" v-for="[subKey, subVal] of Object.entries(setting.data)" :key="subKey">
            <div class="json-key">
              {{ copy.days[subKey] || copy[subKey] }}
            </div>

            <div v-for="[tKey] of Object.entries(subVal)" :key="tKey">
              <input type="time" v-model="clonedSettings[key].data[subKey][tKey]">
            </div>
          </div>
        </div>

        <template v-if="setting.type === 'Boolean'">
          <div>
            <input type="radio" id="true" value="true" v-model="setting.data">
            <label for="true">Ja</label>

            <input type="radio" id="false" value="false" v-model="setting.data">
            <label for="false">Nej</label>
          </div>
        </template>

        <select v-model="setting.data" v-if="setting.key === 'timeslotInterval'">
          <option>5</option>
          <option>10</option>
          <option>15</option>
          <option>30</option>
        </select>

        <input type="number" v-model="setting.data" v-if="setting.type === 'Integer' && setting.key !== 'timeslotInterval'">
      </li>
    </ul>

    <BlockedSlots @blockedSlots="blockedSlots" />
    <ProgressButton text="Spara ändringar" :callback="save" v-if="dirty" />
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import { clone } from 'lodash';
  import BlockedSlots from 'components/admin/blocked-slots';
  import ProgressButton from 'components/progress-button';

  export default {
    name: 'Settings',
    components: { ProgressButton, BlockedSlots },
    data () {
      return {
        dirty: null,
        clonedSettings: {},
        copy: {
          timeslotLimit: 'Pizzor per slot',
          openingHours: 'Slottider mellan',
          openingOffset: 'Öppet för beställning',
          openForOrders: 'Beställning öppen',
          timeslotInterval: 'Slotlängd (5/10/15/30 min)',
          weekdays: 'Vardagar',
          weekends: 'Helg',
          opensAt: 'Öppnar',
          closesAt: 'Stänger',
          days: ['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag', 'Söndag']
        }
      };
    },
    computed: {
      ...mapState('order', ['settings'])
    },

    watch: {
      settings (settings) {
        this.clonedSettings = clone(settings);
      },
      clonedSettings: {
        handler (val) {
          if (Object.keys(val).length > 0) {
            this.dirty = this.dirty !== null;
          }
        },
        deep: true
      }
    },

    mounted () {
      this.clonedSettings = clone(this.settings);
    },

    methods: {
      blockedSlots (slots) {
        this.clonedSettings.blockedSlots.data = slots;
      },

      async save () {
        await this.$store.dispatch('order/saveSettings', this.clonedSettings);
        await this.$store.dispatch('order/loadSettings');
        this.dirty = false;
      }
    }

  };
</script>

<style lang="stylus" scoped>
  @require '~global/colors'
  @require '~global/typo-admin'
  @require '~global/helpers'

  .settings
    max-width: 600px
    margin: 0 auto
    padding-bottom: 4rem

    h1
      @extend .t-header
      text-align: center

    h2
      @extend .t-subHeader

    p,
    .setting,
    .json
      margin-bottom: 1rem

    input[type='text'],
    input[type='number'],
    select
      @extend .t-base
      width: 100%
      font-size: 16px
      padding: .5rem .6rem
      border-radius: 4px
      border: 1px solid rgb(220,220,200)
      margin-bottom: .4rem
      -webkit-appearance: none

    select
      -webkit-appearance: menulist

    input[type='radio']
      border: 1px solid rgb(220,220,200)
      height: 1rem
      width: 1rem

  .time-container
    display: flex

  .time-container .json
    margin-right: 1rem
</style>
